
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface SeoToolSelectorProps {
  selectedTool: string;
  setSelectedTool: (tool: string) => void;
}

export const SeoToolSelector = ({ selectedTool, setSelectedTool }: SeoToolSelectorProps) => {
  return (
    <Tabs value={selectedTool} onValueChange={setSelectedTool} className="mb-6">
      <TabsList className="grid grid-cols-4">
        <TabsTrigger value="seo-analysis">SEO Analysis</TabsTrigger>
        <TabsTrigger value="keyword-research">Keyword Research</TabsTrigger>
        <TabsTrigger value="backlink-checker">Backlink Checker</TabsTrigger>
        <TabsTrigger value="site-speed">Site Speed</TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default SeoToolSelector;
